module.exports = __webpack_public_path__ + "img/1x.f794933.jpg";